import { connect } from 'react-redux'
import ForgotPasswordForm from './forgot-password-form'
import { sendForgotEmail } from '../redux/forgot-password.actions'
import { getForgotPasswordRequestState } from '../redux/forgot-password.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => ({
  pending: getForgotPasswordRequestState(state).pending
})

const mapDispatchToProps = dispatch => ({
  onSubmit: ({ email }) => dispatch(sendForgotEmail(email)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordForm)
